export default __webpack_public_path__ + "static/media/slide-3.dafb8494.jpg";